import { useQuery } from '@tanstack/react-query';

import { get } from '../api/ventura/product';
import { camelCaseKeys } from '../util/object';
import { useConfig } from './useConfig';

function useProduct(adGroupId: number, productId: number) {
  const { apiHost } = useConfig();

  const product = useQuery({
    queryKey: ['product', adGroupId, productId],
    queryFn: () => (productId ? get(apiHost, Number(adGroupId), Number(productId)) : {}),
    select: camelCaseKeys,
  });

  return product
}

export default useProduct;
